import Axios from 'axios'
import store from '../store'

const device = {
  getFreeroomUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_FREEROOM
  },
  getClientIdFreeroom() {
    return store.getters['Client/clientIdFreeroom']
  },
  getDevicesStatus () {
    return Axios.get(`${this.getFreeroomUrl()}/api/internal/clients/${this.getClientIdFreeroom()}/things/info`)
  },
  getDashboards () {
    return Axios.get(`/api/v1/clients/${this.getClientIdFreeroom()}/dashboards/sensors`)
  },
  saveSensors (payload, dashboardId) {
    if(payload.id){
      return Axios.put(`/api/v1/clients/${this.getClientIdFreeroom()}/dashboards/${dashboardId}/sensors`, payload)
    } else {
      return Axios.post(`/api/v1/clients/${this.getClientIdFreeroom()}/dashboards/${dashboardId}/sensors`, payload)
    }
  },
  removeSensor(id, dashboardId) {
    return Axios.delete(`/api/v1/clients/${this.getClientIdFreeroom()}/dashboards/${dashboardId}/sensors/${id}`)
  }
}
export default device